import { AUTO_LAUNCH_RULES } from "../../config/gameplay";
import { clamp } from "../../utils/math";
import type { OrbitForgeSave } from "../save/types";

export function autoLaunchDurationMultiplier(save: OrbitForgeSave): number {
  const level = save.stats.AutoLaunchDurationLevel;
  return clamp(1 + level * 0.06 + Math.max(0, level - 15) * 0.035, 1, 3);
}

export function autoLaunchBallsPerSecond(save: OrbitForgeSave): number {
  const level = save.stats.AutoLaunchRateLevel;
  return clamp(
    AUTO_LAUNCH_RULES.baseBallsPerSecond + level * 0.16 + Math.max(0, level - 20) * 0.08,
    AUTO_LAUNCH_RULES.baseBallsPerSecond,
    AUTO_LAUNCH_RULES.maxBallsPerSecond
  );
}
